module.exports = __webpack_public_path__ + "static/img/shake_hand_icon.901fb0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shake_hand_icon.png
// module id = wxKE
// module chunks = 1